import React, { Component } from 'react';
//import './WeightBenefitsTabs.css';
import _ from 'lodash';

class CapabilityTbody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    render() {

        let countConpenScore = [];
        return (
            <tbody>
                {this.props.competeData &&  !_.isEmpty(this.props.benefitsData) && 
                    this.props.competeData.map((i,index )=> {

                        if( this.props.groupId === i.groupId && this.props.segmentId === i.segmentId){

                            let oldI = this.props.competeOldData.find(r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId );

                            return (
                                <tr>
                                    { this.props.competitorsGroupsData.map((competitorsData, key) => {
                                        if(competitorsData.important){
                                            return(
                                            <td className='parent-td'>
                                                <td className='child-td'><div className='td-box'>

                                                    {i.criticalCapacity.map((critItem,index )=> {
                                                    
                                                        let defData = critItem.competitors ?critItem.competitors.find(r =>  r.competitorId === competitorsData.competitorId) : false;
                                                        
                                                        let critItemOld = oldI.criticalCapacity.find(r => r.text === critItem.text )

                                                        let oldDefData = critItemOld.competitors ? critItemOld.competitors.find(r =>  r.competitorId === competitorsData.competitorId) : false;
                                                        
                                                        return ( 
                                                            <div className='td-box-small'>
                                                                <select   className='form-control' 
                                                                    value={defData ? defData.rating : 1} 
                                                                    onChange={(e)=>this.props.onChangeCompetitorsRatingValue(e, i, competitorsData, index)} 
                                                                    style={{outline: 'none'}}>
                                                                    <option value='1'>1</option>
                                                                    <option value='2'>2</option>
                                                                    <option value='3'>3</option>
                                                                    <option value='4'>4</option>
                                                                    <option value='5'>5</option>
                                                                    <option value='6'>6</option>
                                                                    <option value='7'>7</option>
                                                                    <option value='8'>8</option>
                                                                    <option value='9'>9</option>
                                                                    <option value='10'>10</option>
                                                                </select>
                                                                <div className='position-number'>
                                                                    { oldDefData.rating - defData.rating}
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div></td>
                                                <td className='child-td'><div className='td-box'>
                                                {i.criticalCapacity.map((critItem,index )=> { 
                                                    

                                                    let rateVal = critItem.competitors ?critItem.competitors.find(r =>  r.competitorId === competitorsData.competitorId) : {rating: '1'};

                                                    let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;

                                                    countConpenScore.push({
                                                        score: valScore,
                                                        competitorId: competitorsData.competitorId
                                                    })
                                                    // countConpenScore = +countConpenScore + valScore;

                                                    return  <div className='score-box'> 
                                                        {valScore ? valScore : critItem.ccWt }
                                                        
                                                    </div> 
                                                })} 

                                            </div></td>
                                            </td>
                                        )}
                                    })}
                                </tr>
                        )}
                })}
                
                <tr className='last-row'>
                    { this.props.competitorsGroupsData.map((competitorsData, key) => {
                        
                        if(competitorsData.important){
                            let val = 0;
                            countConpenScore.map((item, key) => {
                                if(item.competitorId === competitorsData.competitorId ) {
                                    val = val + +item.score
                                }

                            })
                            return <td className='parent-td'>
                                <td className='child-td'></td>
                                <td className=' child-td first-value'>
                                    <strong>{val}</strong>
                                </td>
                            </td>
                        }
                    })}
                </tr>
            </tbody>
        )
    }
}
export default (CapabilityTbody);


// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Result/WeightBenefitsTabs/CapabilityTbody/CapabilityTbody.jsx